import apiFetch from '../apiFetch'

export default function (token, documentId, organizedUnitId, fields, lastAccessDate) {
  const queryParams = organizedUnitId ? `?organizedUnitId=${organizedUnitId}` : '?organizedUnitId=null'
  return apiFetch({ endPoint: `document/${documentId}/validate${queryParams}`, body: fields, method: 'PUT', token: token, lastAccessDate })
}
